import { DefaultSidebar, Sidebar, useDevice } from "@excalidraw/excalidraw";
import { trackEvent } from "@excalidraw/excalidraw/analytics";
import { usersIcon } from "@excalidraw/excalidraw/components/icons";
import { MyBoardsPanel } from "../my-boards/MyBoardsPanel";

const MY_BOARDS_TAB = "my-boards";

// pro100доска: this is a HOST-level instance of DefaultSidebar (no
// `__fallback`) — withInternalFallback.tsx makes a host instance take over
// entirely and suppresses the internal fallback that LayerUI.tsx renders,
// so the onDock tracking below has to replicate what that fallback used to
// do, not just add a tab on top of it.
export const AppDefaultSidebar = () => {
  const device = useDevice();

  return (
    <>
      <DefaultSidebar.TabTriggers>
        <Sidebar.TabTrigger tab={MY_BOARDS_TAB}>
          {usersIcon}
        </Sidebar.TabTrigger>
      </DefaultSidebar.TabTriggers>
      <DefaultSidebar
        onDock={(docked) => {
          trackEvent(
            "sidebar",
            `toggleDock (${docked ? "dock" : "undock"})`,
            `(${device.editor.isMobile ? "mobile" : "desktop"})`,
          );
        }}
      >
        <Sidebar.Tab tab={MY_BOARDS_TAB}>
          <MyBoardsPanel />
        </Sidebar.Tab>
      </DefaultSidebar>
    </>
  );
};
